import React from 'react';
import Button from '@mui/material/Button';

const AccessDenied = () => {
  const goToLogin = () => {
    window.location.href = '/login';
  };

  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh'}}>
      <div className="card" style={{padding: 24, textAlign: 'center', maxWidth: 480}}>
        <h2>Acceso denegado</h2>
        <p>No tienes permiso para ver esta página. Por favor, inicia sesión con una cuenta autorizada.</p>
        <div style={{marginTop: 16}}>
          <Button variant="contained" color="primary" onClick={goToLogin}>Ir a Login</Button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
